
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UserPlus } from "lucide-react";
import { useResponsiveLayout } from "../useResponsiveLayout";

interface AddMemberFormProps {
  onAddMember: (email: string, fullName: string, role: string) => Promise<boolean>;
  isAdding: boolean;
}

export const AddMemberForm = ({ onAddMember, isAdding }: AddMemberFormProps) => {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [role, setRole] = useState("MEMBER");
  const { isMobile, isTablet } = useResponsiveLayout();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await onAddMember(email, fullName, role);
    if (success) {
      setEmail("");
      setFullName("");
      setRole("MEMBER");
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Add New Member</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className={`flex flex-col ${!isMobile ? 'sm:flex-row' : ''} gap-4`}>
            <Input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              className="w-full"
            />
            <Input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full"
            />
            <Select value={role} onValueChange={setRole}>
              <SelectTrigger className={`w-full ${!isMobile ? 'sm:w-[200px]' : ''}`}>
                <SelectValue placeholder="Select role" />
              </SelectTrigger>
              <SelectContent position="popper" sideOffset={5} className="w-full">
                <SelectItem value="MEMBER">Member</SelectItem>
                <SelectItem value="ADMIN">Admin</SelectItem>
              </SelectContent>
            </Select>
            <Button type="submit" disabled={isAdding} className={`${isMobile ? 'w-full' : ''}`}>
              <UserPlus className="mr-2 h-4 w-4" />
              {isAdding ? 'Adding...' : 'Add Member'}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
